import {MinMaxBetAmountDefaultBox} from './min-max-bet-amount.default.box';
import {styledByTheme} from '../../../../../themes/architecture/styled-by-theme';
import {MinMaxBetAmountCasino777Box} from './min-max-bet-amount.casino777.box';
import {MinMaxBetAmountSIBox} from './min-max-bet-amount.si.box';
import {MinMaxBetAmountMrGreenBox} from './min-max-bet-amount.mrgreen.box';
import { MinMaxBetAmountCisBox } from './min-max-bet-amount.cis.box';

export const MinMaxBetAmountBox = styledByTheme(MinMaxBetAmountDefaultBox)
    .forCasino777(MinMaxBetAmountCasino777Box)
    .forSI(MinMaxBetAmountSIBox)
    .forMrGreen(MinMaxBetAmountMrGreenBox)
    .forMrGreenCis(MinMaxBetAmountMrGreenBox)
    .forCis(MinMaxBetAmountCisBox)
    .forCip(MinMaxBetAmountCisBox)
    .apply();